<div class="error-panel">
	<div class="error-icon-container">
		<mat-icon class="error-icon" color="primary">error</mat-icon>
	</div>
	<p>{{'LABEL_ERROR_OCCURRED' | translate}}</p>
</div>
